/*
 * @Author:  Bai.Zhiming
 * @Date: 2019-7-20
 * @LastEditTime: 2021-03-15 16:16:28
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\IM\chatTipBar\directive\DropDownList\CTBDrapDownList.js
 * @Description:  Bai.Zhiming
 */
angular.module('CTBDrapDownListModule', [])
    . directive('ctbDrapDownList', ['$templateRequest', '$timeout', '$q', '$compile',
        function($templateRequest, $timeout, $q, $compile) {
            return {
                restrict: 'A',
                replace: false,
                scope: false,
                link(scope, $element, $attrs) {
                    $timeout(() => {
                        initStatus();
                        initData();
                    });

                    /**
                 * [getTemplate description] 获取模板
                 * @return {[type]} [description]
                 */
                    function getTemplate() {
                        let deffer = $q.defer();
                        $templateRequest('./IM/chatTipBar/directive/DropDownList/CTBDrapDownList_tpl.html').then((template) => {
                            let $template = $compile(template)(scope);
                            $element.append($template);
                            deffer.resolve(template);
                        });
                        return deffer.promise;
                    }

                    /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                    function initStatus() {
                        scope.status = {};
                        scope.data = {};
                        // let data = {};
                        // // angular.extend(scope.status, status);
                        // angular.extend(scope.data, data);
                        getTemplate();
                    }

                    /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                    function initData() {}
                }
            };
        }
    ]);
